exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".personage-page .form-content .el-form-item__label{font-size:16px}.personage-page .form-content .el-form-item__content{font-size:16px;color:#212121}.personage-page .el-upload--picture-card:hover,.personage-page .el-upload:focus{border-color:unset;color:unset}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-110ec5c7","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/account/personage.vue
// module id = 827
// module chunks = 0